import moment from 'moment-timezone'
import { mapRegionsToFilterAbbreviations } from 'utils/countriesStates'
import { FORMATS } from 'constants/datetime'
import { EQUIPMENT } from 'constants/equipment'

export const today = moment().format(FORMATS.dateFormat)
export const tomorrow = moment().add(1, 'days').format(FORMATS.dateFormat)

const formatCurrentUserId = (state, currentUserId = '') => {
  if (state) return { usersId: currentUserId, usersType: 'user' }
  return { usersId: '', usersType: '' }
}

const formatSelectedEquipment = state => {
  const selectedEquipment = EQUIPMENT.find(equip => equip.key === state) || {}
  return { equipment: { id: selectedEquipment.id, key: selectedEquipment.key } }
}

const formatSelectedPodId = state => state.filter(obj => obj.selected).map(obj => obj.value)

const formatSelectedRegion = (state, separateRegionsForBooking) =>
  mapRegionsToFilterAbbreviations(state, separateRegionsForBooking)
const checkboxFilterObj = state =>
  state.reduce((o, key) => Object.assign(o, { [key.value]: key.selected }), {})
const formatShipperRateType = rate => {
  if (rate === 'spot_backup') {
    return ['spot', 'contract_backup']
  }
  if (rate === 'primary_backup') {
    return ['contract_primary', 'contract_backup']
  }
  if (Array.isArray(rate)) {
    return rate
  }

  return rate ? [rate] : []
}

const issueStateObj = state => {
  if (!state) return undefined
  if (state === 'all') return ['pending', 'in_progress', 'awaiting_response']
  return [state]
}

export const updateSearchParams = state => {
  const {
    brokerPodKey,
    checkboxFilters,
    currentUserId,
    deliveryDates,
    deliveryLocation,
    deliveryRegion,
    equipment,
    issueState,
    myIssues,
    myLoads,
    pickupDates,
    pickupLocation,
    pickupRegion,
    podIds,
    pricingType,
    query,
    radius,
    separateRegionsForBooking,
    shipperRateType,
    stateOptions,
    status,
    usersId,
    usersType,
  } = state

  const companyUserParams = { usersId, usersType }
  const myLoadsUserParams = formatCurrentUserId(myLoads, currentUserId)
  const userParams = myLoads ? myLoadsUserParams : companyUserParams

  const equipmentParams = formatSelectedEquipment(equipment)
  const podIdsParams = formatSelectedPodId(podIds)
  const pickupRegionParams = formatSelectedRegion(pickupRegion, separateRegionsForBooking)
  const deliveryRegionParams = formatSelectedRegion(deliveryRegion, separateRegionsForBooking)
  const checkboxFilterParams = checkboxFilterObj(checkboxFilters)
  const shipperRateTypeParams = formatShipperRateType(shipperRateType)
  const issueStateParams = issueStateObj(issueState)
  const {
    afterHours,
    backhaulEligible,
    dropTrailer,
    hasClaims,
    hasHot,
    hasOptions,
    hasRolled,
    inComplianceReview,
    multiDay,
    needsComplianceReview,
    needsTracking,
    noAppointmentTime,
    unconfirmedAppointment,
  } = checkboxFilterParams
  const [pickupDate = '', pickupEndDate = ''] = pickupDates
  const [deliveryDate = '', deliveryEndDate = ''] = deliveryDates
  const issuesOwnerId = myIssues ? currentUserId : undefined

  const searchParams = {
    ...userParams,
    ...equipmentParams,
    issuesOwnerId,
    status: stateOptions || status,
    podIds: [...podIdsParams],
    pickupCity: pickupLocation.city,
    pickupStateCode: pickupLocation.state,
    pickupRegions: pickupRegionParams,
    deliveryCity: deliveryLocation.city,
    deliveryStateCode: deliveryLocation.state,
    deliveryRegions: deliveryRegionParams,
    pickupDate,
    pickupEndDate,
    pricingType,
    deliveryDate,
    deliveryEndDate,
    query,
    pickup_miles: radius,
    delivery_miles: radius,
    hasHot,
    hasRolled,
    noAppointmentTime,
    unconfirmedAppointment,
    hasClaims,
    multiDay,
    stateOptions,
    afterHours,
    hasOptions,
    dropTrailer,
    brokerPodKey,
    backhaulEligible,
    needsTracking,
    needsComplianceReview,
    inComplianceReview,
    shipperRateType: shipperRateTypeParams,
    issueStates: issueStateParams,
  }

  if (hasOptions) searchParams.hasOptions = false
  else searchParams.hasOptions = undefined

  return searchParams
}
